import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FolderKanban,
  FileText,
  Receipt,
  Wallet,
  FileStack,
  Settings as SettingsIcon,
  Sparkles,
} from "lucide-react";
import { useAuth } from "@/lib/auth.jsx";

const items = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testId: "nav-dashboard", module: "Dashboard" },
  { to: "/leads", label: "Leads", icon: Sparkles, testId: "nav-leads", module: "Leads" },
  { to: "/clients", label: "Clients", icon: Users, testId: "nav-clients", module: "Clients" },
  { to: "/projects", label: "Projects", icon: FolderKanban, testId: "nav-projects", module: "Projects" },
  { to: "/invoices", label: "Invoices", icon: FileText, testId: "nav-invoices", module: "Invoices" },
  { to: "/payments", label: "Payments", icon: Wallet, testId: "nav-payments", module: "Payments" },
  { to: "/expenses", label: "Expenses", icon: Receipt, testId: "nav-expenses", module: "Expenses" },
  { to: "/templates", label: "Templates", icon: FileStack, testId: "nav-templates", module: "Templates" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testId: "nav-settings", module: "Settings" },
];

export default function Sidebar() {
  const { hasModuleAccess } = useAuth();
  const visibleItems = items.filter((item) => item.to === "/settings" || hasModuleAccess(item.module));
  return (
    <aside className="hidden lg:flex w-[248px] shrink-0 flex-col border-r border-border bg-white/90" data-testid="sidebar">
      <div className="px-6 pt-7 pb-6 border-b border-border bg-white">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-bronze/90 flex items-center justify-center text-black font-display font-semibold shadow-sm">A</div>
          <div className="leading-tight">
            <div className="text-sm font-display font-semibold tracking-tight text-slate-900">Acharya</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">Holdings</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1 bg-[linear-gradient(180deg,rgba(255,255,255,0.96),rgba(248,246,242,0.96))]">
        <div className="px-3 pb-2 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Workspace</div>
        {visibleItems.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={it.testId}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive
                  ? "bg-[#f7efe1] text-slate-900 border border-[#c5a059]/40 shadow-sm"
                  : "text-slate-500 hover:text-slate-900 hover:bg-[#f8f6f2] border border-transparent"
              }`
            }
          >
            <it.icon className="w-4 h-4 group-hover:text-bronze transition-colors" strokeWidth={1.6} />
            <span className="font-medium">{it.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-border bg-white">
        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mb-1">Version</div>
        <div className="text-xs text-slate-500 font-mono">v2.0 · enterprise</div>
      </div>
    </aside>
  );
}
